<template>
  <div id="app">
    <AppNav />
    <ArtistsList
      :selectedArtist="globalArtist"
    />
  </div>
</template>

<script>
import AppNav from './AppNav.vue';
import ArtistsList from './ArtistsList.vue';

const formatDateTimeLocal = (dateStr) => {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export default {
  name: 'App',
  components: {
    AppNav,
    ArtistsList
  },
  data() {
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    
    return {
      globalStartTime: formatDateTimeLocal(yesterday),
      globalEndTime: formatDateTimeLocal(now),
      globalStage: 'all',
      globalArtist: 'all'
    };
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 20px;
  min-height: 100vh;
  background: #f0f2f5;
}

/* 为了避免时间筛选器遮挡内容，给主内容添加上边距 */
.total-chart-container {
  margin-top: 80px;
}

.areas-container {
  margin-top: 20px;
}
</style>
